<template>

  <div>
    <div class="data-types">
      <div class="title">
        <gl-sub-text>このユーザーがダウンロード可能なデータ</gl-sub-text>
      </div>
      <md-checkbox v-model="_dataTypes" value="idpos"
        >ID付ジャーナル</md-checkbox
      >
      <md-checkbox v-model="_dataTypes" value="pos"
        >日店商品サマリ</md-checkbox
      >
    </div>
    <div class="error" v-if="dataTypesInValid || this.dataTypes.length === 0">使用可能なデータ種別を選択してください</div>
    <div class="itemCategory" v-if="companies.length > 0">

      <div class="title">
        <gl-sub-text>企業別分類使用可否</gl-sub-text>
      </div>

      <md-radio
          v-for="c in companies"
          :value="c.code"
          :model="activeTab"
          :key="c.code"
          @change="$emit('update:activeTab', $event)"
          >{{ c.name }}</md-radio
      >
      <!-- <md-tabs
        :md-active-tab="activeTab"
        @md-changed="$emit('update:activeTab', $event)"
      >
        <md-tab 
          v-for="c in companies"
          :key="c.code"
          :id="c.code"
          :md-label="c.name"
          >
        </md-tab> 
      </md-tabs> -->
      <div>
        <available-category
          :company="activeTab"
          v-bind.sync="category"
          @update:category="category = $event"
        />
      </div>
    <div class="error" v-if="categoriesInValid">分類が指定されていない企業があります。</div>

  </div>
</div>

</template>

<script>
import AvailableCategory from '@/components/Category.vue'

/**
 * メーカー選択コンポーネント
 */
export default {
  components: {
    AvailableCategory,
  },
  props: {
    activeTab: {
      type: String,
    },
    dataTypes: {
      type: Array,
      default: () => ['pos', 'idpos'],
    },
    companies: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Object,
      required: true,
    },
    dataTypesInValid: {
      type: Boolean,
      defalut: false,
    },
    categoriesInValid: {
      type: Boolean,
      defalut: false,
    },
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    _dataTypes: {
      get() {
        return this.dataTypes
      },
      set(newVal) {
        this.$emit('update:dataTypes', newVal)
      },
    },
    sortCompanies() {
      return this.companies.slice()
    },
  },
  methods: {},
  async created() {},
}
</script>

<style lang="scss" scoped>
.makers-container {
  position: relative;
  height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid var(--color-border);
  border-radius: 5px;
}

.no-maker {
  background: rgba(0, 0, 0, 0.12);

  &::after {
    font-family: 'Material Icons';
    content: 'ALL MAKER';
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    font-size: 58px;
    color: rgba(0, 0, 0, 0.12);
  }
}

.maker-select-dialog {
  min-width: 700px;
}

.button-dialog-close {
  position: fixed;
  top: 6px;
  right: 0;
}

.maker-select-methods,
.maker-select,
.makers-container {
  margin-top: var(--spacing-medium);
}

.maker-select {
  padding-left: calc(var(--spacing-large) * 2);
}

.actions {
  width: 100%;
  text-align: right;
  display: flex;
  align-items: center;

  .left {
    flex: 1;
  }
}

.maker-count {
  margin-right: var(--spacing-medium);
}

.exceeds-limit {
  color: var(--color-warn);
}
</style>
